import { RouteRecordRaw } from "vue-router";
import { PermissionEnum } from "@altertec_gparn/lib";

export default {
  path: "hr",
  name: "HR",
  meta: { sectionAccess: "HR", redirects: true },
  component: () => import("@/layouts/EmptyLayout.vue"),
  children: [
    {
      path: "employees",
      name: "Employees View",
      redirect: { name: "Employee List" },
      meta: { permissions: [PermissionEnum.HR_EMPLOYEES] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "detail/:id",
          name: "Employee Detail",
          redirect: { name: "Employee Data" },
          component: () => import("@/views/auth/hr/employee/EmployeeDetail.vue"),
          props: true,
          children: [
            {
              path: "data",
              name: "Employee Data",
              component: () => import("@/modules/hr/components/tabs/EmployeeDataTab.vue"),
              props: true,
            },
            {
              path: "hiring-data",
              name: "Employee Hiring Data",
              component: () => import("@/modules/hr/components/tabs/EmployeeHiringDataTab.vue"),
              props: true,
            },
            {
              path: "qualifications",
              name: "Employee's Qualifications",
              components: {
                default: () => import("@/modules/hr/components/tabs/EmployeeQualificationsTab.vue"),
                sidebar: () => import("@/modules/hr/components/sidebars/EmployeeHasQualificationSidebar.vue"),
              },
              props: true,
            },
            {
              path: "vacations",
              name: "Employee's Vacations",
              components: {
                default: () => import("@/modules/hr/components/tabs/EmployeeVacationsTab.vue"),
                sidebar: () => import("@/modules/hr/components/sidebars/AdjustVacationDaysSidebar.vue"),
              },
              props: true,
            },
            {
              path: "calendar",
              name: "Employee Calendar",
              component: () => import("@/modules/hr/components/tabs/EmployeeCalendarTab.vue"),
              props: true,
            },
            {
              path: "sessions",
              name: "Employee's Sessions",
              component: () => import("@/modules/hr/components/tabs/EmployeeSessionsTab.vue"),
              props: true,
            },
            {
              path: "documentation",
              name: "Employee Documentation",
              meta: { permissions: [PermissionEnum.HR_EMPLOYEE_DOCUMENTS] },
              component: () => import("@/modules/hr/components/tabs/EmployeeDocumentationTab.vue"),
              props: true,
            },
          ],
        },
        {
          path: "list",
          name: "Employee List",
          component: () => import("@/views/auth/hr/employee/Employees.vue"),
          children: [
            {
              path: "import",
              name: "Employees Import",
              components: {
                sidebar: () => import("@/modules/hr/components/sidebars/ImportEmployeesSidebar.vue"),
              },
            },
          ],
        },
        {
          path: "edit/:id",
          name: "Edit Employee",
          props: true,
          component: () => import("@/views/auth/hr/employee/EditEmployee.vue"),
        },
        {
          path: "hiring-data/edit/:id",
          name: "Edit Employee Hiring Data",
          props: true,
          component: () => import("@/views/auth/hr/employee/EditEmployeeHiringData.vue"),
        },
      ],
    },
    {
      path: "times-off",
      name: "Times Off",
      redirect: { name: "Times Off List" },
      meta: { permissions: [PermissionEnum.HR_TIMES_OFF] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "new",
          name: "Create Time Off",
          component: () => import("@/views/auth/hr/time-off/TimeOffCreate.vue"),
        },
        {
          path: "list",
          name: "Times Off List",
          component: () => import("@/views/auth/hr/time-off/TimeOffList.vue"),
        },
        {
          path: "detail/:id",
          name: "Time Off Detail",
          redirect: { name: "Time Off Sidebar" },
          component: () => import("@/views/auth/hr/time-off/TimeOffDetailLayout.vue"),
          props: true,
          children: [
            {
              path: "",
              name: "Time Off Sidebar",
              components: { sidebar: () => import("@/modules/times-off/components/sidebars/TimeOffSidebar.vue") },
              props: true,
            },
          ],
        },
      ],
    },
    {
      path: "posts",
      name: "Post View",
      redirect: { name: "Post List" },
      meta: { permissions: [PermissionEnum.HR_POSTS] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "list",
          name: "Post List",
          component: () => import("@/views/auth/hr/posts/Posts.vue"),
        },

        {
          path: "create",
          name: "Create Post",
          component: () => import("@/views/auth/hr/posts/CreatePost.vue"),
        },
        {
          path: ":id",
          name: "Detail Post",
          props: true,
          component: () => import("@/views/auth/hr/posts/PostDetail.vue"),
        },
      ],
    },
    {
      path: "payrolls",
      name: "Payrolls View",
      redirect: { name: "Payroll List" },
      meta: { permissions: [PermissionEnum.HR_PAYROLLS] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "detail/:id",
          name: "Payroll Detail",
          redirect: { name: "Payroll Summary" },
          props: true,
          component: () => import("@/views/auth/hr/payrolls/PayrollDetail.vue"),
          children: [
            {
              path: "summary",
              name: "Payroll Summary",
              component: () => import("@/modules/hr/components/tabs/PayrollSummaryTab.vue"),
              props: true,
            },
            {
              path: "worked-days",
              name: "Payroll Worked Days",
              component: () => import("@/modules/hr/components/tabs/PayrollWorkedDaysTab.vue"),
              props: true,
            },
          ],
        },
        {
          path: "list",
          name: "Payroll List",
          component: () => import("@/views/auth/hr/payrolls/PayrollList.vue"),
        },
        {
          path: "payroll-pluses/:type?/:id?",
          name: "Payroll Pluses Configuration",
          meta: { permissions: [PermissionEnum.HR_CONFIGURATION] },
          component: () => import("@/views/auth/configuration/payrolls/PayrollPlusesConfiguration.vue"),
          props: true,
        },
        {
          path: "point-configurations/:type?/:id?",
          name: "Point Configurations",
          meta: { permissions: [PermissionEnum.HR_CONFIGURATION] },
          component: () => import("@/views/auth/configuration/payrolls/PointConfigurations.vue"),
          props: true,
        },
        {
          path: "point-price-configurations/:type?/:id?",
          name: "Point Price Configurations",
          meta: { permissions: [PermissionEnum.HR_CONFIGURATION] },
          component: () => import("@/views/auth/configuration/payrolls/PointPriceConfigurations.vue"),
          props: true,
        },
      ],
    },
    {
      path: "onboarding",
      name: "HR Onboarding View",
      redirect: { name: "HR Onboarding List" },
      meta: { permissions: [PermissionEnum.HR_ONBOARDING] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "list",
          name: "HR Onboarding List",
          component: () => import("@/views/auth/hr/onboarding/OnboardingList.vue"),
        },
        {
          path: "new",
          name: "HR Onboarding New",
          meta: { permissions: [PermissionEnum.HR_ONBOARDING, PermissionEnum.USERS_CREATE] },
          component: () => import("@/views/auth/configuration/users/UserCreate.vue"),
          props: { onboardingMode: true },
        },
        {
          path: "document-types/:type?/:id?",
          name: "Employee Document Categories",
          meta: { permissions: [PermissionEnum.HR_CONFIGURATION] },
          component: () => import("@/views/auth/configuration/EmployeeDocumentCategories.vue"),
          props: true,
        },
        {
          path: "employee-document-categories/:type?/:id?",
          redirect: (to) => ({
            name: "Employee Document Categories",
            params: to.params,
          }),
        },
        {
          path: "signature-templates/:type?/:id?",
          redirect: (to) => ({
            name: "Employee Document Categories",
            params: to.params,
          }),
        },
        {
          path: "detail/:userId",
          name: "HR Onboarding Detail",
          props: true,
          redirect: (to) => ({ name: "HR Onboarding Process", params: to.params }),
          component: () => import("@/views/auth/hr/onboarding/OnboardingDetail.vue"),
          children: [
            {
              path: "summary",
              name: "HR Onboarding Summary",
              redirect: (to) => ({ name: "HR Onboarding Process", params: to.params }),
            },
            {
              path: "process",
              name: "HR Onboarding Process",
              component: () => import("@/modules/hr/components/tabs/onboarding/OnboardingProcessTab.vue"),
              props: true,
            },
            {
              path: "review-queue",
              name: "HR Onboarding Review Queue",
              component: () => import("@/modules/hr/components/tabs/onboarding/OnboardingReviewQueueTab.vue"),
              props: true,
            },
          ],
        },
      ],
    },
    {
      path: "qualifications",
      name: "HR Qualifications View",
      redirect: { name: "HR Qualifications" },
      meta: { permissions: [PermissionEnum.HR_CONFIGURATION] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "report",
          name: "HR Qualifications Report",
          meta: { permissions: [PermissionEnum.HR_EMPLOYEES] },
          component: () => import("@/views/auth/scheduler/QualificationsReport.vue"),
          children: [
            {
              path: "edit",
              name: "HR Qualifications Report Edit Sidebar",
              components: {
                sidebar: () => import("@/modules/hr/components/sidebars/QualificationsReportEditSidebar.vue"),
              },
            },
            {
              path: "import",
              name: "HR Qualifications Report Import Sidebar",
              components: {
                sidebar: () => import("@/modules/hr/components/sidebars/ImportUserHasQualificationsSidebar.vue"),
              },
            },
          ],
        },
        {
          path: "copy/:id",
          name: "Duplicate HR Qualification",
          component: () => import("@/views/auth/configuration/DuplicateQualification.vue"),
          props: true,
        },
        {
          path: "training-categories/:type?/:id?",
          name: "Training Categories",
          component: () => import("@/views/auth/configuration/TrainingCategories.vue"),
          props: true,
        },
        {
          path: ":type?/:id?",
          name: "HR Qualifications",
          component: () => import("@/views/auth/configuration/Qualifications.vue"),
          props: true,
          children: [
            {
              path: "import",
              name: "HR Qualifications Import",
              components: {
                sidebar: () => import("@/modules/hr/components/sidebars/ImportQualificationsSidebar.vue"),
              },
            },
          ],
        },
      ],
    },
    {
      path: "configuration",
      name: "HR Configuration",
      redirect: { name: "Collective Agreements" },
      meta: { permissions: [PermissionEnum.HR_CONFIGURATION] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "collective-agreements/detail/:id",
          name: "Collective Agreement Detail",
          redirect: { name: "Collective Agreement Data" },
          component: () => import("@/views/auth/configuration/collective-agreements/CollectiveAgreementDetail.vue"),
          props: true,
          children: [
            {
              path: "data",
              name: "Collective Agreement Data",
              component: () => import("@/modules/hr/components/tabs/CollectiveAgreementDataTab.vue"),
              props: true,
            },
            {
              path: "diet-types",
              name: "Collective Agreement Diet Types",
              component: () => import("@/modules/hr/components/tabs/CollectiveAgreementDietTypesTab.vue"),
              props: true,
            },
            {
              path: "categories",
              name: "Collective Agreement Categories",
              component: () => import("@/modules/hr/components/tabs/CollectiveAgreementCategoriesTab.vue"),
              props: true,
            },
            {
              path: "holidays",
              name: "Collective Agreement Holidays",
              component: () => import("@/modules/hr/components/tabs/CollectiveAgreementHolidaysTab.vue"),
              props: true,
            },
            {
              path: "users",
              name: "Collective Agreement Users",
              meta: { permissions: [PermissionEnum.HR_EMPLOYEES] },
              component: () => import("@/modules/hr/components/tabs/CollectiveAgreementUsersTab.vue"),
              props: true,
            },
          ],
        },
        {
          path: "collective-agreements/:type?/:id?",
          name: "Collective Agreements",
          component: () => import("@/views/auth/configuration/collective-agreements/CollectiveAgreements.vue"),
          props: true,
        },
        {
          path: "time-off-types/:type?/:id?",
          name: "Time Off Types",
          component: () => import("@/views/auth/configuration/TimeOffTypes.vue"),
          props: true,
        },
        {
          path: "on-call-types/:type?/:id?",
          name: "On Call Types",
          component: () => import("@/views/auth/configuration/OnCallTypes.vue"),
          props: true,
        },
        {
          path: "training-categories/:type?/:id?",
          redirect: (to) => ({
            name: "Training Categories",
            params: to.params,
          }),
        },
        {
          path: "employee-document-categories/:type?/:id?",
          redirect: (to) => ({
            name: "Employee Document Categories",
            params: to.params,
          }),
        },
        {
          path: "signature-templates/:type?/:id?",
          redirect: (to) => ({
            name: "Employee Document Categories",
            params: to.params,
          }),
        },
        {
          path: "document-types/:type?/:id?",
          redirect: (to) => ({
            name: "Employee Document Categories",
            params: to.params,
          }),
        },
        {
          path: "qualifications/copy/:id",
          redirect: (to) => ({
            name: "Duplicate HR Qualification",
            params: { id: to.params.id },
          }),
        },
        {
          path: "qualifications/:type?/:id?",
          redirect: (to) => ({
            name: "HR Qualifications",
            params: to.params,
          }),
        },
        {
          path: "payroll-pluses/:type?/:id?",
          redirect: (to) => ({
            name: "Payroll Pluses Configuration",
            params: to.params,
          }),
        },
        {
          path: "point-configurations/:type?/:id?",
          redirect: (to) => ({
            name: "Point Configurations",
            params: to.params,
          }),
        },
        {
          path: "point-price-configurations/:type?/:id?",
          redirect: (to) => ({
            name: "Point Price Configurations",
            params: to.params,
          }),
        },
        {
          path: "operative-units/:type?/:id?",
          name: "HR Operative Units",
          component: () => import("@/views/auth/configuration/operative-units/OperativeUnits.vue"),
          props: true,
        },
        {
          path: "diet-types/:type?/:id?",
          name: "HR Diet Types",
          component: () => import("@/views/auth/configuration/DietTypes.vue"),
          props: true,
        },
      ],
    },
  ],
} as RouteRecordRaw;
